var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "widget widget-availability" },
    [
      _vm.initial_variation_id
        ? [
            _vm.availability === 1
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "var-avail text-right d-inline-block w-100",
                      class: _vm.classes,
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$translate("Ecomsilio::Template.availability1")
                          ) +
                          ", " +
                          _vm._s(
                            _vm.$translate(
                              "Ecomsilio::Template.variationShippingDuration"
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "var-avail-zusatz font-weight-normal text-right",
                    },
                    [
                      _vm._v(
                        "\n        (" +
                          _vm._s(
                            _vm.$translate(
                              "Ecomsilio::Template.itemShippingTimeBefore"
                            )
                          ) +
                          "\n        "
                      ),
                      _c("u", [
                        _c(
                          "a",
                          {
                            staticClass: "text-appearance",
                            attrs: {
                              "data-toggle": "modal",
                              href: "#shippingscosts",
                              title: _vm.$translate(
                                "Ceres::Template.itemShippingCosts"
                              ),
                            },
                            on: {
                              "~click": function ($event) {
                                return _vm.$store.dispatch(
                                  "loadComponent",
                                  "shippingscosts-modal"
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ecomsilio::Template.shippingInformation"
                                )
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(")\n      "),
                    ]
                  ),
                ]
              : _vm.availability === 5 && _vm.isMainVariant === false
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "var-avail text-right d-inline-block w-100",
                      class: _vm.classes,
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$translate("Ecomsilio::Template.availability5")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("bw-availability-notification", {
                    attrs: {
                      "item-id": _vm.currentItemId,
                      "variation-id": _vm.currentVariation,
                      language: _vm.currentLanguage,
                    },
                  }),
                ]
              : _vm.availability === 5 && _vm.isMainVariant === true
              ? _c(
                  "div",
                  {
                    staticClass: "var-avail text-right d-inline-block w-100",
                    class: _vm.classes,
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$translate("Ecomsilio::Template.availability5")
                        ) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.availability === 1 && _vm.isMainVariant === false
              ? _c(
                  "div",
                  { staticClass: "font-weight-bold mt-2" },
                  [
                    _vm.currentStock < 10 && _vm.currentStock > 0
                      ? [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$translate(
                                  "Ecomsilio::Template.currentStock",
                                  { count: _vm.currentStock }
                                )
                              ) +
                              "\n      "
                          ),
                        ]
                      : [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$translate(
                                  "Ecomsilio::Template.availableStockText"
                                )
                              ) +
                              "\n      "
                          ),
                        ],
                  ],
                  2
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }